import * as React from 'react'
import { atLeastOneOf, Status } from '@yobora/models/rights'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { Menu } from 'antd'
import { State } from 'src/app.store'
import { pipe } from 'fp-ts/lib/pipeable'
import { fold } from 'fp-ts/lib/Option'
import { MenuItemProps } from 'antd/lib/menu/MenuItem'

/**
 * Display a menu based on the current user Rights
 */
const MenuItem = connect((state: State) => ({
  userrights: pipe(
    state.login.identity,
    fold(() => [], user => user.rights)
  )
}))(({ dispatch, ...restProps }: MenuItemProps & { rights: Status[]; userrights: Status[]; dispatch: Dispatch }) =>
  atLeastOneOf(...restProps.rights)(restProps.userrights) ? <Menu.Item {...restProps} /> : <div />
)

export default MenuItem



// WEBPACK FOOTER //
// ./src/utils-components/guarded/MenuItem.tsx